<template>
  <div class="servicePart">
    <h2>Our Service</h2>
    <a-row :gutter="32" type="flex">
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 12 }"
        :md="{ span: 8 }"
        v-for="ser in serDesc"
      >
        <a-card>
          <img :alt="ser.title" :src="ser.link" slot="cover" />
          <a-card-meta :title="ser.title" :description="ser.description">
          </a-card-meta>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "ServicePart",
  props: ["serDesc"]
};
</script>

<style lang="scss">
.servicePart {
  .ant-card {
    margin-bottom: 3em;
    transition: all 0.5s ease;

    &:hover {
      transform: scale(1.1);
      -webkit-transform: scale(1.1);
    }
  }
}
</style>
